import * as React from 'react';

const Be16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "M1 5a2 2 0 0 1 2-2h2.667v10H3a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFE936", d: "M5.667 3h4.667v10H5.667z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FF0F21", d: "M10.334 3H13a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2.666z" }));
Be16.Size = 16;
Be16.Title = "Be";

export { Be16 as default };
